import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Switch, Route, matchPath } from 'react-router-dom';
import classNames from 'classnames';
import { toast } from 'react-toastify';
import numeral from 'numeral';
import lodash from 'lodash';

import axios from '../../../axios';

import './style.scss';
import Table from './../../../components/table/index';
import TableSort from './../../../components/table/TableSort';
import {
    getInfoMatchInGame, ACTIONS_GAMES,
    convertInfoMatchInGame, convertInfoMatchInGame3,
    getGameResultGeneral, convertGameResultGeneral1, convertHeaderGameResultGeneral2, convertGameResultGeneral2,
    getGameResultOutting, getGameAnalytics, convertGameAnalytics, getGameResultInnings, getInfoGame,
    addPitcherPlayer
} from '../../../actions/games';
import Loading from '../../../components/loading';
import { detectIconById } from '../../../common/enum';

import TabGame from './TabGame';
import TeamUserTopic from "../team/team-user-topic";
import moment from 'moment';
import SearchPlayer from './SearchPlayer';
import { CSVLink } from "react-csv";

// import { ACTIONS } from '../../../actions/team-public';

const getParams = pathname => {
    const matchProfile = matchPath(pathname, {
        path: `/game/:id/:teamId/:day/topic/:topicId`,
    });
    return (matchProfile && matchProfile.params) || {};
};

const DEFAULT_GAME_OUTING = {
    avg: null,
    ab: null,
    r: null,
    h: null,
    rbi: null,
    so: null,
    bb: null,
    sh: null,
    sb: null,
    e: null,
    hr: null
};

class Game extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            tabIndex: 0,
            showLoading: false,
            isShowGame2: false,
            statusSubmenu: false,
            isDetailGame: false,
            isShowDetailGame1: false,
            isShowTabGame2: true,
            idGame: 0,
            awayPlayerName: '',
            homePlayerName: '',
            listHome: [],
            listAway: [],
            listHomePitcher: [],
            listAwayPitcher: [],
            nameAwayTable: '',
            nameHomeTable: '',
            infoMatchInGame: [],
            table2: [],
            tableDetail1: [],
            headerDetail2: [],
            tableDetail2: [],
            startingAwayPitcher: [],
            startingAwayBatter: [],
            startingHomePitcher: [],
            startingHomeBatter: [],
            titleTablePitcherResult: [],
            isDownloading: false,

            home: {
                teamIdAway: 0,
                teamIdHome: 0,
                teamNameAway: "",
                teamNameHome: "",
                teamNameAway_s: "",
                teamNameHome_s: "",
                playerNameAway: "",
                playerNameHome: "",
                round: "",
                day: "",
                time: "",
            },
            listResultGameOuttingPitchersAway: [],
            listResultGameOuttingPitchersHome: [],
            listResultGameOuttingAway: [],
            listResultGameOutting: [],
            listResultGameOuttingHome: [],
            listResultGameOuttingTotal: {
                away: DEFAULT_GAME_OUTING,
                home: DEFAULT_GAME_OUTING
            },
            dataInnings: [],
            totalInnings: {
                top: 0,
                bottom: 0
            }
        }
        this.onRedirect = this.onRedirect.bind(this);
        this.onRedirectTeam = this.onRedirectTeam.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        if (nextProps.response) {

            if (nextProps.status === ACTIONS_GAMES.GET_INFO_GAME_ID_SUCCESS) {
                this.setState({
                    showLoading: false,
                    stadiumName: nextProps.response.data ? nextProps.response.data[0].stadium_name : "",
                    home: {
                        teamIdAway: nextProps.response.data ? nextProps.response.data[0].away_team.id : 0,
                        teamIdHome: nextProps.response.data ? nextProps.response.data[0].home_team.id : 0,
                        teamNameAway: nextProps.response.data ? nextProps.response.data[0].away_team.team_name : "",
                        teamNameAway_s: nextProps.response.data ? nextProps.response.data[0].away_team.team_name_s : "",
                        teamNameHome: nextProps.response.data ? nextProps.response.data[0].home_team.team_name : "",
                        teamNameHome_s: nextProps.response.data ? nextProps.response.data[0].home_team.team_name_s : "",
                        round: nextProps.response.data ? nextProps.response.data[0].round : null,
                        day: nextProps.response.data ? moment(nextProps.response.data[0].game_date + nextProps.response.data[0].scheduled_game_start_hms, "YYYY/MM/DD hhmm").format('llll') : "",
                        time: nextProps.response.data ? nextProps.response.data[0].scheduled_game_start_hms.toString().substring(0, 4) : "",
                        playerNameAway: nextProps.response.data && nextProps.response.data[0].pitchers.away ? nextProps.response.data[0].pitchers.away.player_name : "",
                        playerIdAway: nextProps.response.data && nextProps.response.data[0].pitchers.away ? nextProps.response.data[0].pitchers.away.id : "",
                        pitcherIsAnnouncedAway: nextProps.response.data && nextProps.response.data[0].pitchers.away ? !!nextProps.response.data[0].pitchers.away.is_announced : false,
                        playerIdHome: nextProps.response.data && nextProps.response.data[0].pitchers.home ? nextProps.response.data[0].pitchers.home.id : "",
                        playerNameHome: nextProps.response.data && nextProps.response.data[0].pitchers.home ? nextProps.response.data[0].pitchers.home.player_name : "",
                        pitcherIsAnnouncedHome: nextProps.response.data && nextProps.response.data[0].pitchers.home ? !!nextProps.response.data[0].pitchers.home.is_announced : false,
                    },
                });

                if (nextProps.response.data[0].home_team.id) {
                    const param = this.props.match.params;
                    const data = {
                        game_id: param.id,
                        team_id: nextProps.response.data[0].home_team.id
                    }
                    // console.log(data);
                    this.props.getInfoMatchInGame(data);
                }
            }

            if (nextProps.status === ACTIONS_GAMES.GET_INFO_GAMES_SUCCESS) {
                this.setState({
                    // homeTeamName: res.home_team.team_name,
                    // awayTeamName: res.away_team.team_name,
                    // timeStartGameDate: res.scheduled_game_start_ymd,
                    // timeStartGameHours: res.scheduled_game_start_hms,
                    // stadiumName: res.stadium_name,
                    // homePlayerName: res.pitchers.home.player_name,
                    // awayPlayerName: res.pitchers.away.player_name,
                    showLoading: false,
                    isShowTabGame2: false,
                    infoMatchInGame: nextProps.response.scorelines,
                    table2: convertInfoMatchInGame(nextProps.response.summary),
                });
            }
            if (nextProps.status === ACTIONS_GAMES.GET_INFO_DETAIL_GAMES_SUCCESS) {
                // let res = nextProps.response;
                // this.setState({
                //     nameAwayTable: res.away.pitcher.team.team_name,
                //     nameHomeTable: res.home.pitcher.team.team_name,
                //     listHome: converDataDetailGames(res.home),
                //     listAway: converDataDetailGames(res.away),
                //     showLoading: false
                // })
            }
            if (nextProps.status === ACTIONS_GAMES.GET_GAME_RESULT_GENERAL_SUCCESS) {
                let nameAway = nextProps.response.startings && nextProps.response.startings.home.batters[0] ? nextProps.response.startings.home.batters[0].player.player.team.team_name : '';
                let nameHome = nextProps.response.startings && nextProps.response.startings.away.batters[0] ? nextProps.response.startings.away.batters[0].player.player.team.team_name : '';
                this.setState({
                    showLoading: false,
                    tableDetail1: convertGameResultGeneral1(nextProps.response),
                    headerDetail2: convertHeaderGameResultGeneral2(nextProps.response),
                    tableDetail2: convertGameResultGeneral2(nextProps.response),
                    startingAwayPitcher: nextProps.response.startings ? nextProps.response.startings.away.pitchers : null,
                    startingAwayBatter: nextProps.response.startings ? nextProps.response.startings.away.batters : null,
                    startingHomePitcher: nextProps.response.startings ? nextProps.response.startings.home.pitchers : null,
                    startingHomeBatter: nextProps.response.startings ? nextProps.response.startings.home.batters : null,
                    titleTablePitcherResult: nextProps.titleTablePitcherResult,
                })
            }
            if (nextProps.status === ACTIONS_GAMES.GET_GAME_RESULT_OUTTING_SUCCESS) {
                this.setState({
                    showLoading: false,
                    listResultGameOuttingAway: nextProps.response.away ? nextProps.response.away.batters : null,
                    listResultGameOuttingHome: nextProps.response.home ? nextProps.response.home.batters : null,
                    listResultGameOuttingTotal: {
                        away: nextProps.response.away ? nextProps.response.away.total : DEFAULT_GAME_OUTING,
                        home: nextProps.response.home ? nextProps.response.home.total : DEFAULT_GAME_OUTING
                    },
                    listResultGameOuttingPitchersAway: nextProps.response.away ? nextProps.response.away.pitchers : null,
                    listResultGameOuttingPitchersHome: nextProps.response.home ? nextProps.response.home.pitchers : null,
                });
            }


            if (nextProps.status === ACTIONS_GAMES.GET_GAME_ANALYTICS_SUCCESS) {
                this.setState({
                    showLoading: false,
                    listHome: convertGameAnalytics(nextProps.response.home),
                    listAway: convertGameAnalytics(nextProps.response.away),
                    listHomePitcher: nextProps.response.home && nextProps.response.home.pitcher ? nextProps.response.home.pitcher.player_name : '',
                    listAwayPitcher: nextProps.response.away && nextProps.response.away.pitcher ? nextProps.response.away.pitcher.player_name : ''
                })
            }

            if (nextProps.status === ACTIONS_GAMES.GET_GAME_RESULT_INNINGS_SUCCESS) {
                this.setState({
                    dataInnings: nextProps.response.data || [],
                    totalInnings: nextProps.response.result || this.state.totalInnings
                })

            }
        } else {
            this.setState({
                showLoading: false
            })
        }
    }

    componentDidMount() {
        this.setState({ showLoading: true });
        this.getIdParamsGame();
        if (this.props.location.state && this.props.location.state.finish) {
            this.setState({
                isDetailGame: true,
            });
        }
    }

    getIdParamsGame() {
        let id = this.props.match.params.id;
        id && this.setState({ idGame: id });
        // this.props.getInfoMatchInGame();
        // this.props.getInfoDetailGame(id);
        this.props.getGameAnalytics(id);
        this.props.getInfoGame(id);
        this.props.getGameResultGeneral(id);
        // this.props.getInfoPitcherGame(id);
        if (this.props.location.state && this.props.location.state.finish) {
            this.props.getGameResultInnings(id);
            this.props.getGameResultOutting(id);
        }
    }

    showSubmenuPlus() {
        const subMenu = document.getElementById('sub-menu-plus');

        if (!this.state.statusSubmenu) {
            subMenu.style.display = 'block';
            this.setState({
                statusSubmenu: true
            });
        } else {
            this.setState({
                statusSubmenu: false
            });
            subMenu.style.display = 'none';
        }
    }

    showSelectGame() {
        const selectGame = document.getElementById('wrap-select-game');
        selectGame.style.display = 'block';
    }

    hideSelectGame() {
        const selectGame = document.getElementById('wrap-select-game');
        selectGame.style.display = 'none';
    }

    toggle() {
        if (this.state.isDetailGame) {
            this.setState({
                isDetailGame: false,
            });
        } else if (!this.state.startingHomePitcher[0]) {
            // cannot toggle show to Detail Game
            return false;
        } else {
            this.props.getGameResultInnings(this.state.idGame);
            this.props.getGameResultOutting(this.state.idGame);
            this.setState({
                isDetailGame: true,
                showLoading: true,
                isShowDetailGame1: false
            });
        }
        const url = this.props.match.url;
        this.props.history.push(url);
    }

    convertPercentage(number) {
        if (!number) return;

        number = numeral(number).format('0.000');
        if (number < 1) {
            let srt = number.toString();
            srt = srt.substr(1);
            return srt;
        } else {
            return number;
        }
    }

    showDetailGame(e, i) {
        e.target.classList.add('active-tab');
        if (i) {
            e.target.parentNode.firstChild.classList.remove('active-tab');
            this.props.getGameResultOutting(this.props.match.params.id);
            this.setState({
                isShowDetailGame1: true
            });
        } else {
            e.target.nextSibling.classList.remove('active-tab');
            this.props.getGameAnalytics(this.props.match.params.id);
            this.setState({
                isShowDetailGame1: false
            });
        }
    }

    changeTabGame2(e, teamId) {
        if (teamId) {
            let targetTeamid = 0;
            if (teamId == this.state.home.teamIdHome) {
                targetTeamid = this.state.home.teamIdHome;
                e.target.parentNode.lastChild.classList.remove('active-btn');
            } else {
                targetTeamid = this.state.home.teamIdAway;
                e.target.parentNode.firstChild.classList.remove('active-btn');
            }
            e.target.classList.add('active-btn');

            const param = this.props.match.params;

            const data = {
                game_id: param.id,
                team_id: targetTeamid
            }
            this.props.getInfoMatchInGame(data);

            this.setState({
                showLoading: true
            });
        }
    }

    onRedirect(value) {
        this.props.history.push(value.item[0].url);
    }

    onRedirectTeam(id) {
        this.props.history.push('/team-report/' + id);
    }

    onRedirectPlayer(id) {
        this.props.history.push('/player/' + id);
    }

    onChoosePlayer = async (player) => {
        try {
            await this.props.addPitcherPlayer({
                playerId: player.id,
                teamId: player.team.id,
                gameId: this.props.match.params.id,
            });
            this.props.getInfoGame(this.state.idGame);
            this.props.getGameAnalytics(this.state.idGame);
        } catch (error) {
            toast.error('選択された選手を先発投手として登録できません。チーム、ポジションを確認してください。');
        }
    }
    downLoadFileExcel = async () => {
        const id = this.props.match.params.id;
        if (!id) {
            return;
        }
        try {
            this.setState({
                isDownloading: true
            });

            const req = await axios.get(`/api/games/${id}/download`, {
                responseType: 'blob'
            });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(req.data);
            link.download = `game-${id}.zip`;
            link.click();

            this.setState({
                isDownloading: false
            });
        } catch (error) {
            toast.error('エラーが発生しました');
            this.setState({
                isDownloading: false
            });
        }

    }

    renderInnings = (innings) => {
        return <>
            {
                this.state.dataInnings.map((val, i) => <td key={i}>
                    {innings[i] || ''}
                </td>)
            }
        </>
    };

    displayPitcherStatus = (data) => {
        if (data.result.w === 1) {
            return '勝';
        }
        if (data.result.l === 1) {
            return '敗';
        }
        if (data.result.hld === 1) {
            return 'H';
        }
        if (data.result.sv === 1) {
            return 'S';
        }
        return '';
    }

    render() {
        const hasTopic = !!getParams(this.props.history.location.pathname).topicId;
        const paddingRight = hasTopic ? 330 : 0;
        return (
            <Fragment>
                <div className="wrap-game">
                    <div className="title-game" style={{ paddingRight }}>
                        <h3>{this.state.home.teamNameAway_s ? `${this.state.home.teamNameHome_s} - ${this.state.home.teamNameAway_s} ` : ''} {this.state.home.round ? `${this.state.home.round}回戦` : ''}</h3>
                        <div className="switch-button">
                            <button style={{ width: 88 }} className={classNames(this.state.isDetailGame && 'active-btn')}
                                onClick={() => this.toggle()}>
                                試合結果
                            </button>
                            <button style={{ width: 88 }} className={classNames(!this.state.isDetailGame && 'active-btn')}
                                onClick={() => this.toggle()}>
                                分析
                            </button>
                        </div>
                        <button className='button-download' onClick={this.downLoadFileExcel} disabled={this.state.isDownloading}>
                            <img alt="download" src='/img/ic_download_svg.svg' />
                            <span>{this.state.isDownloading ? 'ダウンロード中' : 'GameNotesダウンロード'}</span>
                        </button>
                    </div>
                    {
                        !this.state.isDetailGame
                            ? (<div className="content-game">
                                <div className="title-match" id="title-match" style={{ paddingRight }}>
                                    <div className="people1">
                                        <span className={'label-team'}>ホーム</span>
                                        <h4 className={'team-value'}
                                            onClick={() => this.onRedirectTeam(this.state.home.teamIdHome)}>
                                            {this.state.home.teamNameHome}
                                        </h4>
                                        <div className={'content-wrapper'}>
                                            <label className='label'>先発</label>
                                            <div style={{ width: 150, cursor: 'pointer' }} onClick={() => {
                                                if (!this.state.home.pitcherIsAnnouncedHome) return;
                                                this.onRedirectPlayer(this.state.home.playerIdHome);
                                            }}>
                                                <SearchPlayer
                                                    disabled={true}
                                                    placeholder={'先発投手'}
                                                    teamIds={[this.state.home.teamIdHome]}
                                                    selected={{
                                                        playerName: this.state.home.playerNameHome,
                                                        id: this.state.home.playerIdHome,
                                                    }}
                                                    onChoosePlayer={this.onChoosePlayer}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="time-match">
                                        <div>
                                            <img
                                                style={{ cursor: 'pointer' }}
                                                alt=''
                                                onClick={() => this.onRedirectTeam(this.state.home.teamIdHome)}
                                                src={detectIconById(this.state.home.teamIdHome)}
                                            />
                                            <span>vs</span>
                                            <img
                                                style={{ cursor: 'pointer' }}
                                                alt=''
                                                onClick={() => this.onRedirectTeam(this.state.home.teamIdAway)}
                                                src={detectIconById(this.state.home.teamIdAway)}
                                            />
                                        </div>
                                        <small>{this.state.home.day} </small>
                                        <small>{this.state.stadiumName}</small>
                                    </div>
                                    <div className="people2">
                                        <span className={'label-team'}>ビジター</span>
                                        <h4 className={'team-value'}>
                                            {this.state.home.teamNameAway}
                                        </h4>
                                        <div className='content-wrapper'>
                                            <label className='label'>先発</label>
                                            <div style={{ width: 150, cursor: 'pointer' }} onClick={() => {
                                                if (!this.state.home.pitcherIsAnnouncedAway) return;
                                                this.onRedirectPlayer(this.state.home.playerIdAway);
                                            }}>
                                                <SearchPlayer
                                                    disabled={true}
                                                    placeholder='先発投手'
                                                    teamIds={[this.state.home.teamIdAway]}
                                                    selected={{
                                                        playerName: this.state.home.playerNameAway,
                                                        id: this.state.home.playerIdAway,
                                                    }}
                                                    onChoosePlayer={this.onChoosePlayer}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="tab-content-game">
                                    <div>
                                        <TabGame tabs={['先発情報', '対戦成績']} />
                                    </div>
                                    <div>
                                        <Switch>
                                            <Route path={'/game/:id/:teamId/:day'} exact>
                                                <div className="game-1">
                                                    <div>
                                                        <div>
                                                            <h4>打者別成績</h4>
                                                            <p>先発：{this.state.listAwayPitcher}</p>
                                                        </div>
                                                        <div>
                                                            <Table showPagination={false} showCheckbox={false}
                                                                header={this.props.header}
                                                                itemOfPage={this.state.listAway}
                                                                onRowClick={this.onRedirect} />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div>
                                                            <h4>打者別成績</h4>
                                                            <p>先発：{this.state.listHomePitcher}</p>
                                                        </div>
                                                        <div>
                                                            <Table showPagination={false} showCheckbox={false}
                                                                header={this.props.header}
                                                                itemOfPage={this.state.listHome}
                                                                onRowClick={this.onRedirect} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Route>
                                            <Route path={'/game/:id/:teamId/:day/game-2'} exact>
                                                <div className="game-2">
                                                    <div>
                                                        <h4>対戦</h4>
                                                        <div>
                                                            <button style={{ width: 100 }} className='active-btn' onClick={(e) => this.changeTabGame2(e, `${this.state.home.teamIdHome}`)}>{this.state.home.teamNameHome_s}</button>
                                                            <button style={{ width: 100 }} onClick={(e) => this.changeTabGame2(e, `${this.state.home.teamIdAway}`)}>{this.state.home.teamNameAway_s}</button>
                                                        </div>
                                                    </div>
                                                    {
                                                        this.state.isShowTabGame2
                                                            ? (
                                                                <div>
                                                                    <div>
                                                                        {
                                                                            this.state.table2
                                                                                ? <Table
                                                                                    showPagination={false}
                                                                                    titleTable={this.props.titleTable}
                                                                                    header={this.props.header2}
                                                                                    itemOfPage={this.state.table2}
                                                                                    showCheckbox={false}
                                                                                />
                                                                                : null
                                                                        }

                                                                    </div>
                                                                    <div className='list-match-record'>
                                                                        <h4>対戦成績(公式戦) </h4>
                                                                        <h4>{this.state.monthScores}</h4>
                                                                        <TableSort
                                                                            showPagination={false}
                                                                            header={this.props.header3}
                                                                            itemOfPage={this.state.table3}
                                                                            showCheckbox={false}
                                                                        />
                                                                        <h4>4月</h4>
                                                                        <TableSort
                                                                            showPagination={false}
                                                                            header={this.props.header3}
                                                                            itemOfPage={this.props.table3}
                                                                            showCheckbox={false}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )
                                                            : (
                                                                <div>
                                                                    <div>
                                                                        <Table
                                                                            showPagination={false}
                                                                            titleTable={this.props.titleTable}
                                                                            header={this.props.header2}
                                                                            itemOfPage={this.state.table2}
                                                                            showCheckbox={false}
                                                                        />
                                                                    </div>

                                                                    <div className='list-match-record'>
                                                                        <h4>対戦成績(公式戦) </h4>
                                                                        {
                                                                            this.state.infoMatchInGame && this.state.infoMatchInGame.length
                                                                                ?
                                                                                this.state.infoMatchInGame[0].map((v, i) => {
                                                                                    return (
                                                                                        <Fragment key={i}>
                                                                                            <div className='match-record-month'>
                                                                                                <h4>{v.month}月</h4>
                                                                                            </div>
                                                                                            <TableSort
                                                                                                showPagination={false}
                                                                                                header={this.props.header3}
                                                                                                itemOfPage={convertInfoMatchInGame3(v.games)}
                                                                                                showCheckbox={false}
                                                                                            />
                                                                                        </Fragment>
                                                                                    )
                                                                                })
                                                                                : null
                                                                        }
                                                                    </div>
                                                                </div>
                                                            )
                                                    }
                                                </div>
                                            </Route>
                                            <Route path={'/game/:id/:teamId/:day/topic/:topicId'}
                                                exact component={TeamUserTopic} />
                                        </Switch>
                                    </div>
                                </div>
                            </div>)
                            : (
                                <div className="wrap-detail-game">
                                    <div className="detail-game-title">
                                        <div className="title-detail">
                                            <div className="left">
                                                <div>
                                                    <h4>ホーム</h4>
                                                    <div onClick={() => this.onRedirectTeam(this.state.home.teamIdHome)}>
                                                        {this.state.home.teamNameHome ?
                                                            <img style={{ cursor: 'pointer' }} alt='logo'
                                                                src={detectIconById(this.state.home.teamIdHome)} /> : null}
                                                        <label
                                                            style={{ cursor: 'pointer' }}>{this.state.home.teamNameHome}</label>
                                                    </div>
                                                </div>
                                                <div>
                                                    <p>VS</p>
                                                    <p>{this.state.home.day}</p>
                                                    <p>{this.state.stadiumName}</p>
                                                </div>
                                                <div>
                                                    <h4>ビジター</h4>
                                                    <div onClick={() => this.onRedirectTeam(this.state.home.teamIdAway)}>
                                                        {this.state.home.teamNameAway ?
                                                            <img style={{ cursor: 'pointer' }} alt='logo'
                                                                src={detectIconById(this.state.home.teamIdAway)} /> : null}
                                                        <label
                                                            style={{ cursor: 'pointer' }}>{this.state.home.teamNameAway}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="right">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>チーム</th>
                                                            {
                                                                this.state.dataInnings.map((val, i) => {
                                                                    return <th key={i}>{val.inning}</th>
                                                                })
                                                            }
                                                            <th className={'detail-game-header-color'}>計</th>
                                                            <th className={'detail-game-header-color'}>安</th>
                                                            <th className={'detail-game-header-color'}>失</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>{this.state.home.teamNameAway_s}</td>
                                                            {
                                                                this.state.dataInnings.map((val, i) => {
                                                                    return <td
                                                                        key={i}>{lodash.get(val.top, 'r', '') + (lodash.get(val.top, 'is_x', '') ? 'X' : '')}</td>
                                                                })
                                                            }
                                                            <td className='detail-game-body-color'>{this.state.totalInnings.top.total}</td>
                                                            <td className='detail-game-body-color'>{this.state.totalInnings.top.h}</td>
                                                            <td className='detail-game-body-color'>{this.state.totalInnings.top.r}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{this.state.home.teamNameHome_s}</td>
                                                            {
                                                                this.state.dataInnings.map((val, i) => {
                                                                    return <td
                                                                        key={i}>{lodash.get(val.bottom, 'r', '') + (lodash.get(val.bottom, 'is_x', '') ? 'X' : '')}</td>
                                                                })
                                                            }
                                                            <td className='detail-game-body-color'>{this.state.totalInnings.bottom.total}</td>
                                                            <td className='detail-game-body-color'>{this.state.totalInnings.bottom.h}</td>
                                                            <td className='detail-game-body-color'>{this.state.totalInnings.bottom.r}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div style={{ padding: '0 24px' }}>
                                            <TabGame tabs={['基本情報', '出場成績']} />
                                        </div>
                                    </div>
                                    <div className="detail-game-content">
                                        <Switch>
                                            <Route path={'/game/:id/:teamId/:day/game-2'} exact>
                                                <div>
                                                    <div className="wrap-list-result">
                                                        <h4>打撃成績一覧</h4>
                                                        <table>
                                                            <thead>
                                                                <tr>
                                                                    <th>
                                                                        <span>打順</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>位置</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>選手名</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>打率</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>打数</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>得点</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>安打</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>打点</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>三振</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>四死</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>犠打</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>盗塁</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>失策</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>本塁打</span>
                                                                    </th>
                                                                    {
                                                                        this.state.dataInnings.map((val, i) => {
                                                                            return <th key={i}>
                                                                                <span>{i + 1}回</span>
                                                                            </th>
                                                                        })
                                                                    }
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    this.state.listResultGameOuttingAway && this.state.listResultGameOuttingAway.map((val, i) => {
                                                                        return (
                                                                            <tr
                                                                                key={i}
                                                                                onClick={val.order.player.is_active ? () => {
                                                                                    this.onRedirectPlayer(val.order.player.id);
                                                                                } : undefined}
                                                                            >
                                                                                <td>
                                                                                    {val.order.batting_order}
                                                                                </td>
                                                                                <td>
                                                                                    {lodash.get(val.order, 'positions', []).map((position, idx) => {
                                                                                        return <span
                                                                                            key={idx + 'result-game-outting'}
                                                                                            style={{ border: position.is_starting ? '1px solid #ddd' : 'none' }}>
                                                                                            {position.position_name_s}
                                                                                        </span>
                                                                                    })}
                                                                                </td>
                                                                                <td>
                                                                                    {val.order.player.player_name}
                                                                                </td>
                                                                                <td>{this.convertPercentage(val.result.avg) || '-'}</td>
                                                                                <td>{val.result.ab}</td>
                                                                                <td>{val.result.r}</td>
                                                                                <td>{val.result.h}</td>
                                                                                <td>{val.result.rbi}</td>
                                                                                <td>{val.result.so}</td>
                                                                                <td>{(val.result.bb + val.result.hbp)}</td>
                                                                                <td>{val.result.sh}</td>
                                                                                <td>{val.result.sb}</td>
                                                                                <td>{val.result.e}</td>
                                                                                <td>{val.result.hr}</td>
                                                                                {
                                                                                    this.renderInnings(val.innings || [])
                                                                                }
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }

                                                                <tr className='row-total-result'
                                                                    style={{ background: '#f0f3f5', cursor: 'default' }}>
                                                                    <td>
                                                                    </td>
                                                                    <td>合計</td>
                                                                    <td>{this.convertPercentage(this.state.listResultGameOuttingTotal.away.avg)}</td>
                                                                    <td>{this.state.listResultGameOuttingTotal.away.ab}</td>
                                                                    <td>{this.state.listResultGameOuttingTotal.away.r}</td>
                                                                    <td>{this.state.listResultGameOuttingTotal.away.h}</td>
                                                                    <td>{this.state.listResultGameOuttingTotal.away.rbi}</td>
                                                                    <td>{this.state.listResultGameOuttingTotal.away.so}</td>
                                                                    <td>{this.state.listResultGameOuttingTotal.away.bb}</td>
                                                                    <td>{this.state.listResultGameOuttingTotal.away.sh}</td>
                                                                    <td>{this.state.listResultGameOuttingTotal.away.sb}</td>
                                                                    <td>{this.state.listResultGameOuttingTotal.away.e}</td>
                                                                    <td>{this.state.listResultGameOuttingTotal.away.hr}</td>
                                                                    {
                                                                        this.state.dataInnings.map((val, i) => {
                                                                            return <td key={i} />
                                                                        })
                                                                    }
                                                                </tr>

                                                                <tr style={{ cursor: 'default' }}>
                                                                    <td colSpan="11" className='img-result-outting'>
                                                                        <div style={{ justifyContent: 'left', paddingLeft: 10 }}>
                                                                            {this.state.home.teamNameAway ? <img alt="img"
                                                                                src={detectIconById(this.state.home.teamIdAway)} /> : ''}
                                                                            <label>{this.state.home.teamNameAway}</label>
                                                                        </div>

                                                                    </td>
                                                                    <td colSpan="2"
                                                                        style={{ background: '#f0f3f5' }}>{this.state.totalInnings.top.total}</td>
                                                                    {
                                                                        this.state.dataInnings.map((val, i) => {
                                                                            return <td
                                                                                key={i}>{lodash.get(val.top, 'r', '') + (lodash.get(val.top, 'is_x', '') ? 'X' : '')}</td>
                                                                        })
                                                                    }
                                                                </tr>
                                                                <tr style={{ cursor: 'default' }}>
                                                                    <td colSpan="11" className='img-result-outting'>
                                                                        <div style={{ justifyContent: 'left', paddingLeft: 10 }}>
                                                                            {this.state.home.teamNameHome ? <img alt="img"
                                                                                src={detectIconById(this.state.home.teamIdHome)}
                                                                                className='img-result-outting' /> : ''}

                                                                            <label>{this.state.home.teamNameHome}</label>
                                                                        </div>
                                                                    </td>
                                                                    <td colSpan="2"
                                                                        style={{ background: '#f0f3f5' }}>{this.state.totalInnings.bottom.total}</td>
                                                                    {
                                                                        this.state.dataInnings.map((val, i) => {
                                                                            return <td
                                                                                key={i}>{lodash.get(val.bottom, 'r', '') + (lodash.get(val.bottom, 'is_x', '') ? 'X' : '')}</td>
                                                                        })
                                                                    }
                                                                </tr>

                                                            </tbody>
                                                        </table>

                                                        <table>
                                                            <thead>
                                                                <tr>
                                                                    <th>
                                                                        <span>打順</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>位置</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>選手名</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>打率</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>打数</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>得点</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>安打</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>打点</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>三振</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>四死</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>犠打</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>盗塁</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>失策</span>
                                                                    </th>
                                                                    <th>
                                                                        <span>本塁打</span>
                                                                    </th>
                                                                    {
                                                                        this.state.dataInnings.map((val, i) => {
                                                                            return <th key={i}>
                                                                                <span>{i + 1}回</span>
                                                                            </th>
                                                                        })
                                                                    }
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    this.state.listResultGameOuttingHome && this.state.listResultGameOuttingHome.map((val, i) => {
                                                                        return (
                                                                            <tr
                                                                                key={i}
                                                                                onClick={val.order.player.is_active ? () => {
                                                                                    this.onRedirectPlayer(val.order.player.id);
                                                                                } : undefined}
                                                                            >
                                                                                <td>
                                                                                    {val.order.batting_order}
                                                                                </td>
                                                                                <td>
                                                                                    {lodash.get(val.order, 'positions', []).map((position, idx) => {
                                                                                        return <span
                                                                                            key={idx + 'result-game-outting'}
                                                                                            style={{ border: position.is_starting ? '1px solid #ddd' : 'none' }}>
                                                                                            {position.position_name_s}
                                                                                        </span>
                                                                                    })}
                                                                                </td>
                                                                                <td>
                                                                                    {val.order.player.player_name}
                                                                                </td>
                                                                                <td>{this.convertPercentage(val.result.avg) || '-'}</td>
                                                                                <td>{val.result.ab}</td>
                                                                                <td>{val.result.r}</td>
                                                                                <td>{val.result.h}</td>
                                                                                <td>{val.result.rbi}</td>
                                                                                <td>{val.result.so}</td>
                                                                                <td>{(val.result.bb + val.result.hbp)}</td>
                                                                                <td>{val.result.sh}</td>
                                                                                <td>{val.result.sb}</td>
                                                                                <td>{val.result.e}</td>
                                                                                <td>{val.result.hr}</td>
                                                                                {
                                                                                    this.renderInnings(val.innings || [])
                                                                                }
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }

                                                                <tr className='row-total-result' style={{ cursor: 'default' }}>
                                                                    <td>
                                                                    </td>
                                                                    <td>合計</td>
                                                                    <td>{this.convertPercentage(this.state.listResultGameOuttingTotal.home.avg)}</td>
                                                                    <td>{this.state.listResultGameOuttingTotal.home.ab}</td>
                                                                    <td>{this.state.listResultGameOuttingTotal.home.r}</td>
                                                                    <td>{this.state.listResultGameOuttingTotal.home.h}</td>
                                                                    <td>{this.state.listResultGameOuttingTotal.home.rbi}</td>
                                                                    <td>{this.state.listResultGameOuttingTotal.home.so}</td>
                                                                    <td>{this.state.listResultGameOuttingTotal.home.bb}</td>
                                                                    <td>{this.state.listResultGameOuttingTotal.home.sh}</td>
                                                                    <td>{this.state.listResultGameOuttingTotal.home.sb}</td>
                                                                    <td>{this.state.listResultGameOuttingTotal.home.e}</td>
                                                                    <td>{this.state.listResultGameOuttingTotal.home.hr}</td>
                                                                    {
                                                                        this.state.dataInnings.map((val, i) => {
                                                                            return <td key={i} />
                                                                        })
                                                                    }
                                                                </tr>


                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    {/* table bottom */}
                                                    <div className="wrap-list-result2">
                                                        <h3>投手成績一覧</h3>
                                                        <div>
                                                            <h4>{this.state.home.teamNameAway}</h4>
                                                            <table>
                                                                <thead>
                                                                    <tr>
                                                                        {
                                                                            this.state.titleTablePitcherResult && this.state.titleTablePitcherResult.map((val, i) =>
                                                                                <th key={i}
                                                                                    style={val.width ? { width: val.width } : null}>
                                                                                    <span>{val.title}</span></th>
                                                                            )
                                                                        }
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        this.state.listResultGameOuttingPitchersAway && this.state.listResultGameOuttingPitchersAway.map((val, i) => {
                                                                            return (
                                                                                <tr
                                                                                    key={i}
                                                                                    onClick={val.player.is_active ? () => {
                                                                                        this.onRedirectPlayer(val.player.id);
                                                                                    } : undefined}
                                                                                >
                                                                                    <td>
                                                                                        {this.displayPitcherStatus(val)}
                                                                                    </td>
                                                                                    <td>
                                                                                        {val.player.player_name}
                                                                                    </td>
                                                                                    <td>{val.result.era || '-'}</td>
                                                                                    <td>{val.result.ip}</td>
                                                                                    <td>{val.result.np}</td>
                                                                                    <td>{val.result.bf}</td>
                                                                                    <td>{val.result.h}</td>
                                                                                    <td>{val.result.hr}</td>
                                                                                    <td>{val.result.so}</td>
                                                                                    <td>{val.result.bb}</td>
                                                                                    <td>{val.result.hbp}</td>
                                                                                    <td>{val.result.r}</td>
                                                                                    <td>{val.result.er}</td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                    }
                                                                </tbody>
                                                            </table>

                                                        </div>
                                                        <div>
                                                            <h4>{this.state.home.teamNameHome}</h4>
                                                            <table>
                                                                <thead>
                                                                    <tr>
                                                                        {
                                                                            this.state.titleTablePitcherResult && this.state.titleTablePitcherResult.map((val, i) =>
                                                                                <th key={i}
                                                                                    style={val.width ? { width: val.width } : null}>
                                                                                    <span>{val.title}</span></th>
                                                                            )
                                                                        }
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        this.state.listResultGameOuttingPitchersHome && this.state.listResultGameOuttingPitchersHome.map((val, i) => {
                                                                            return (
                                                                                <tr
                                                                                    key={i}
                                                                                    onClick={val.player.is_active ? () => {
                                                                                        this.onRedirectPlayer(val.player.id);
                                                                                    } : undefined}
                                                                                >
                                                                                    <td>
                                                                                        {this.displayPitcherStatus(val)}
                                                                                    </td>
                                                                                    <td>
                                                                                        {val.player.player_name}
                                                                                    </td>
                                                                                    <td>{val.result.era || '-'}</td>
                                                                                    <td>{val.result.ip}</td>
                                                                                    <td>{val.result.np}</td>
                                                                                    <td>{val.result.bf}</td>
                                                                                    <td>{val.result.h}</td>
                                                                                    <td>{val.result.hr}</td>
                                                                                    <td>{val.result.so}</td>
                                                                                    <td>{val.result.bb}</td>
                                                                                    <td>{val.result.hbp}</td>
                                                                                    <td>{val.result.r}</td>
                                                                                    <td>{val.result.er}</td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                    </div>
                                                </div>
                                            </Route>
                                            <Route path={'/game/:id/:teamId/:day'} exact>
                                                <div className="wrap-body-detail">
                                                    <div>
                                                        <div>
                                                            <Table titleTable={this.props.titleTableDetail1}
                                                                showPagination={false}
                                                                showCheckbox={false} header={this.props.headerDetail1}
                                                                itemOfPage={this.state.tableDetail1} />
                                                        </div>

                                                        <div>
                                                            <Table titleTable={this.props.titleTableDetail2}
                                                                showPagination={false}
                                                                showCheckbox={false} header={this.state.headerDetail2}
                                                                itemOfPage={this.state.tableDetail2} />
                                                        </div>

                                                    </div>

                                                    <div className='list-starter'>
                                                        <h4>スタメン</h4>
                                                        <div>
                                                            <div>
                                                                <span>{this.state.startingHomePitcher[0] && `${this.state.startingHomePitcher[0].player.player.team.team_name}`}</span>
                                                                <table>
                                                                    <thead>
                                                                        <tr style={{ cursor: 'default' }}>
                                                                            <td>投手</td>
                                                                            <td>ポジション | 選手名</td>
                                                                            <td>投</td>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {this.state.startingHomePitcher[0] && this.state.startingHomePitcher.map((val, i) => {
                                                                            return (
                                                                                <tr
                                                                                    key={i}
                                                                                    onClick={val.player.player.is_active ? () => {
                                                                                        this.onRedirectPlayer(val.player.player.id);
                                                                                    } : undefined}
                                                                                >
                                                                                    <td>先発</td>
                                                                                    <td>
                                                                                        <label>{val.player.position_name_s}</label>{val.player.player.player_name}
                                                                                    </td>
                                                                                    <td>{val.real_throwt_lr.replace('投', '')}</td>
                                                                                </tr>
                                                                            )
                                                                        })}
                                                                        <tr style={{ cursor: 'default' }}>
                                                                            <td>打順</td>
                                                                            <td>ポジション | 選手名</td>
                                                                            <td>打</td>
                                                                        </tr>
                                                                        {this.state.startingHomePitcher[0] && this.state.startingHomeBatter[0] &&
                                                                            this.state.startingHomePitcher[0].player.player.team.team_name === this.state.startingHomeBatter[0].player.player.team.team_name ?
                                                                            this.state.startingHomeBatter.map((val, i) => {
                                                                                return (
                                                                                    <tr
                                                                                        key={i}
                                                                                        onClick={val.player.player.is_active ? () => {
                                                                                            this.onRedirectPlayer(val.player.player.id);
                                                                                        } : undefined}
                                                                                    >
                                                                                        <td>{val.player.batting_order}</td>
                                                                                        <td>
                                                                                            <label>{val.player.position_name_s}</label>{val.player.player.player_name}
                                                                                        </td>
                                                                                        <td>{val.real_bat_lr.replace('打', '')}</td>
                                                                                    </tr>
                                                                                )
                                                                            }) : this.state.startingAwayBatter.map((val, i) => {
                                                                                return (
                                                                                    <tr
                                                                                        key={i}
                                                                                        onClick={val.player.player.is_active ? () => {
                                                                                            this.onRedirectPlayer(val.player.player.id);
                                                                                        } : undefined}
                                                                                    >
                                                                                        <td>{val.player.batting_order}</td>
                                                                                        <td>
                                                                                            <label>{val.player.position_name_s}</label>{val.player.player.player_name}
                                                                                        </td>
                                                                                        <td>{val.real_bat_lr.replace('打', '')}</td>
                                                                                    </tr>
                                                                                )
                                                                            })}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <div>
                                                                <span>{this.state.startingAwayPitcher[0] && `${this.state.startingAwayPitcher[0].player.player.team.team_name}`}</span>
                                                                <table>
                                                                    <thead>
                                                                        <tr style={{ cursor: 'default' }}>
                                                                            <td>投手</td>
                                                                            <td>ポジション | 選手名</td>
                                                                            <td>投</td>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {this.state.startingAwayPitcher[0] && this.state.startingAwayPitcher.map((val, i) => {
                                                                            return (
                                                                                <tr
                                                                                    key={i}
                                                                                    onClick={val.player.player.is_active ? () => {
                                                                                        this.onRedirectPlayer(val.player.player.id);
                                                                                    } : undefined}
                                                                                >
                                                                                    <td>先発</td>
                                                                                    <td>
                                                                                        <label>{val.player.position_name_s}</label>{val.player.player.player_name}
                                                                                    </td>
                                                                                    <td>{val.real_throwt_lr.replace('投', '')}</td>
                                                                                </tr>
                                                                            )
                                                                        })}
                                                                        <tr style={{ cursor: 'default' }}>
                                                                            <td>打順</td>
                                                                            <td>ポジション | 選手名</td>
                                                                            <td>打</td>
                                                                        </tr>
                                                                        {this.state.startingAwayPitcher[0] && this.state.startingAwayBatter[0] &&
                                                                            this.state.startingAwayPitcher[0].player.player.team.team_name === this.state.startingAwayBatter[0].player.player.team.team_name ?
                                                                            this.state.startingAwayBatter.map((val, i) => {
                                                                                return (
                                                                                    <tr
                                                                                        key={i}
                                                                                        onClick={val.player.player.is_active ? () => {
                                                                                            this.onRedirectPlayer(val.player.player.id);
                                                                                        } : undefined}
                                                                                    >
                                                                                        <td>{val.player.batting_order}</td>
                                                                                        <td>
                                                                                            <label>{val.player.position_name_s}</label>{val.player.player.player_name}
                                                                                        </td>
                                                                                        <td>{val.real_bat_lr.replace('打', '')}</td>
                                                                                    </tr>
                                                                                )
                                                                            }) : this.state.startingHomeBatter.map((val, i) => {
                                                                                return (
                                                                                    <tr
                                                                                        key={i}
                                                                                        onClick={val.player.player.is_active ? () => {
                                                                                            this.onRedirectPlayer(val.player.player.id);
                                                                                        } : undefined}
                                                                                    >
                                                                                        <td>{val.player.batting_order}</td>
                                                                                        <td>
                                                                                            <label>{val.player.position_name_s}</label>{val.player.player.player_name}
                                                                                        </td>
                                                                                        <td>{val.real_bat_lr.replace('打', '')}</td>
                                                                                    </tr>
                                                                                )
                                                                            })}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Route>
                                            <Route path={'/game/:id/:teamId/:day/topic/:topicId'}
                                                exact component={TeamUserTopic} />
                                        </Switch>
                                    </div>
                                </div>
                            )
                    }
                </div>

                {/* game info select topic */}
                <Loading show={this.state.showLoading} />
            </Fragment>
        )
    }
}

const mapStateToProps = ({ games }) => {
    return {

        headerDetail1: games.headerDetail1,
        headerDetail2: games.headerDetail2,
        tableDetail1: games.tableDetail1,
        tableDetail2: games.tableDetail2,
        titleTableDetail1: games.titleTableDetail1,
        titleTableDetail2: games.titleTableDetail2,
        header: games.header,
        header2: games.header2,
        header3: games.header3,
        table2: games.table2,
        table22: games.table22,
        table3: games.table3,
        table33: games.table33,
        tab: games.tab,
        titleTable: games.titleTable,
        response: games.response,
        status: games.status,
        titleTablePitcherResult: games.titleTablePitcherResult,

    }
};

const mapDispatchToProps = dispatch => {
    return {
        getInfoMatchInGame: (data) => {
            dispatch(getInfoMatchInGame(data))
        },
        getInfoGame: (id) => {
            dispatch(getInfoGame(id))
        },
        // getInfoPitcherGame: (id) => {
        //     dispatch(getInfoPitcherGame(id))
        // },
        getGameResultGeneral: (gameId) => {
            dispatch(getGameResultGeneral(gameId))
        },
        getGameResultOutting: (gameId) => {
            dispatch(getGameResultOutting(gameId))
        },
        addPitcherPlayer: (params) => dispatch(addPitcherPlayer(params)),
        getGameAnalytics: (gameId) => {
            dispatch(getGameAnalytics(gameId))
        },
        getGameResultInnings: (id) => {
            dispatch(getGameResultInnings(id))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Game);
